import React from "react";

function IrpBenefits() {
  return (
    <div>
      <ul className="list-disc list-outside">
        <li>
          <b>Monthly contributions are tax deductible.</b>The monthly
          contribution is tax deductible at source i.e. your contribution will
          be deducted from your gross pay before P.A.Y.E is computed. The
          current maximum tax deductible contribution is Kshs. 20,000.00 per
          month or a third (1/3) of monthly income whichever is lower.
        </li>
        <li>
          <b>Tax exempt investment income: </b>The interest earned is exempted
          from tax in full.
        </li>
        <li>
          <b>Compound interest:</b> Compound interest accrues on the
          contributions received, leading to a faster accumulation of your fund.
        </li>
        <li>
          <b>Investment income:</b> Contributions are prudently invested to
          ensure high returns with a guaranteed minimum compounded rate of 5%
          per annum.
        </li>
        <li>
          <b>Portability:</b>The plan is portable and is not affected by changes
          in employment.
        </li>
        <li>
          <b>Flexibility: </b>You can vary the contribution made to the plan
          from time to time subject to a minimum of Kshs. 2,000 for every
          payment. You can also vary the frequency of making contributions to
          suit your financial circumstances.
        </li>
        <li>
          <b>Pension backed mortgage:</b>A member can assign up to 60% of the
          accumulated fund towards financing the purchase or construction of a
          house.
        </li>
        <li>
          <b>Guaranteed Capital and Interest: </b>Capital (accumulated benefits)
          is guaranteed against any form of reduction. And Interest rate is
          guaranteed not to fall below 5.00% p.a.
        </li>
        <li>
          <b>Variety: </b> A choice between a Pension and a Provident Fund.
          Pension Fund pays a maximum of a third (1/3) of accumulated benefits
          as a single lump sum and the remaining two thirds (2/3) purchases a
          pension annuity which pays a guaranteed regular income for life or a
          Provident Fund pays the accumulated amount in one single lump sum.
        </li>
        <li>
          In case of death prior to retirement age, the total accumulated amount
          becomes payable to appointed beneficiaries.
        </li>
      </ul>
      <p>
        <b>Other Value added services:</b>
      </p>
      <ul >
        <li>1. Britam will keep you informed of the changes occurring in the pensions industry.

</li>
        <li>2. Britam Individual Pension Scheme is approved to receive NSSF Tier II contributions.

</li>
      </ul>
    </div>
  );
}

export default IrpBenefits;
